import L from "leaflet";
import workerHome from "../assets/Markers/workerHome.svg";
import officeIcon from "../assets/Markers/officeIcon.png";
import good_25_icon from "../assets/Markers/good_25.png";
import good_25_50_icon from "../assets/Markers/good_25-50.png";
import good_50_75_icon from "../assets/Markers/good_50-75.png";
import good_75_100_icon from "../assets/Markers/good_75-100.png";
import good_100_icon from "../assets/Markers/good_100.png";
import bad_25_icon from "../assets/Markers/bad_25.png";
import bad_25_50_icon from "../assets/Markers/bad_25-50.png";
import bad_50_75_icon from "../assets/Markers/bad_50-75.png";
import bad_75_100_icon from "../assets/Markers/bad_75-100.png";
import bad_100_icon from "../assets/Markers/bad_100.png";
import "leaflet-iconmaterial";

import {
  metricIconConfig,
  officeIconConfig,
  materialIcon,
  transportSymbolColor,
} from "../config/iconConfig";

export class IconController {
  static instance: IconController;

  private readonly compactMaterialIconSize: [number, number] = [28, 28];
  private readonly defaultMaterialIconSize = materialIcon.size as [
    number,
    number,
  ];

  constructor() {
    // @ts-ignore
    this.icons = {
      officeIcon: L.icon({
        iconUrl: officeIcon,
        // @ts-ignore
        iconSize: officeIconConfig.size,
        // @ts-ignore
        iconAnchor: officeIconConfig.anchor,
      }),
      good_25: L.icon({
        iconUrl: good_25_icon,
        // @ts-ignore
        iconSize: metricIconConfig.size,
        // @ts-ignore
        iconAnchor: metricIconConfig.anchor,
      }),
      good_25_50: L.icon({
        iconUrl: good_25_50_icon,
        // @ts-ignore
        iconSize: metricIconConfig.size,
        // @ts-ignore
        iconAnchor: metricIconConfig.anchor,
      }),
      good_50_75: L.icon({
        iconUrl: good_50_75_icon,
        // @ts-ignore
        iconSize: metricIconConfig.size,
        // @ts-ignore
        iconAnchor: metricIconConfig.anchor,
      }),
      good_75_100: L.icon({
        iconUrl: good_75_100_icon,
        // @ts-ignore
        iconSize: metricIconConfig.size,
        // @ts-ignore
        iconAnchor: metricIconConfig.anchor,
      }),
      bad_25: L.icon({
        iconUrl: bad_25_icon,
        // @ts-ignore
        iconSize: metricIconConfig.size,
        // @ts-ignore
        iconAnchor: metricIconConfig.anchor,
      }),
      bad_25_50: L.icon({
        iconUrl: bad_25_50_icon,
        // @ts-ignore
        iconSize: metricIconConfig.size,
        // @ts-ignore
        iconAnchor: metricIconConfig.anchor,
      }),
      bad_50_75: L.icon({
        iconUrl: bad_50_75_icon,
        // @ts-ignore
        iconSize: metricIconConfig.size,
        // @ts-ignore
        iconAnchor: metricIconConfig.anchor,
      }),
      bad_75_100: L.icon({
        iconUrl: bad_75_100_icon,
        // @ts-ignore
        iconSize: metricIconConfig.size,
        // @ts-ignore
        iconAnchor: metricIconConfig.anchor,
      }),
      bad_100: L.icon({
        iconUrl: bad_100_icon,
        // @ts-ignore
        iconSize: metricIconConfig.size,
        // @ts-ignore
        iconAnchor: metricIconConfig.anchor,
      }),
      good_100: L.icon({
        iconUrl: good_100_icon,
        // @ts-ignore
        iconSize: metricIconConfig.size,
        // @ts-ignore
        iconAnchor: metricIconConfig.anchor,
      }),
      workerHome: L.icon({
        iconUrl: workerHome,
        iconSize: [20, 40],
        iconAnchor: [10, 40],
      }),
    };
  }

  static getInstance() {
    if (!IconController.instance) {
      IconController.instance = new IconController();
    }
    return IconController.instance;
  }

  getIcon(key: string) {
    // @ts-ignore
    if (this.icons[key]) {
      // @ts-ignore
      return this.icons[key];
    } else {
      return null;
    }
  }

  getColoredIcon(
    r: number | null = null,
    g: number | null = null,
    b: number | null = null,
    rgbString: string | null = null,
  ) {
    // console.log("getColoredIcon is called.");
    //check if parameters r g b were given
    if (r !== null && g !== null && b !== undefined && !rgbString) {
      const markerHtmlStyles = `
                background-color: rgb(${r},${g},${b});
                height: 22px;
                width: 22px;
                transform: rotate(45deg);
                border-radius: 15px 15px 0px;
                position: absolute;
                border-style: solid;
                border-width: 1px;
                `;

      return L.divIcon({
        className: "my-custom-pin",
        iconAnchor: L.point(15, 30),
        popupAnchor: [0, -36],
        html: `<span style="${markerHtmlStyles}"><span>`,
      });
    } else if (rgbString) {
      const markerHtmlStyles = `
                background-color: ${rgbString};
                height: 22px;
                width: 22px;
                transform: rotate(45deg);
                border-radius: 15px 15px 0px;
                position: absolute;
                border-style: solid;
                border-width: 1px;
                `;

      return L.divIcon({
        className: "my-custom-pin",
        iconAnchor: [11, 22],
        popupAnchor: [0, -36],
        html: `<span style="${markerHtmlStyles}"><span>`,
      });
    } else {
      return null;
    }
  }

  getMaterialIcon(
    materialString: string,
    transportType: keyof typeof materialIcon.fillColor,
    sizeVariant: "default" | "compact" = "default",
  ) {
    // console.log("getMaterialIcon is called.");
    // console.log("materialString: ", materialString);
    // console.log("transportType: ", transportType);
    // console.log(
    //   "materialIcon.fillColor[transportType]: ",
    //   materialIcon.fillColor[transportType],
    // );
    // console.log(
    //   "materialIcon.borderColor[transportType]: ",
    //   materialIcon.borderColor[transportType],
    // );

    const isCompact = sizeVariant === "compact";
    const iconSize = isCompact
      ? this.compactMaterialIconSize
      : this.defaultMaterialIconSize;
    const iconAnchor: [number, number] = isCompact ? [14, 28] : [17.5, 35];
    const popupAnchor: [number, number] = isCompact ? [0, -28] : [0, -35];
    const markerDiameter = isCompact ? 24 : 30;
    const transportIconFontSize = isCompact ? 18 : 24;

    // Detect if fillColor is a gradient or solid color
    const fillColor = materialIcon.fillColor[transportType];

    // DEBUG: Add error checking for undefined fillColor
    if (!fillColor) {
      // console.error(
      //   "ICON ERROR: No fillColor found for transportType:",
      //   transportType,
      // );
      // console.error(
      //   "Available fillColor keys:",
      //   Object.keys(materialIcon.fillColor),
      // );
      // console.error(
      //   "Available borderColor keys:",
      //   Object.keys(materialIcon.borderColor),
      // );
      // Return a default icon to prevent crash
      return L.divIcon({
        className: "custom-div-icon-error",
        iconSize: iconSize,
        iconAnchor: iconAnchor,
        popupAnchor: popupAnchor,
        html: `
          <div style="
            background-color: #ff0000;
            border: 2px solid #990000;
            width: ${markerDiameter}px;
            height: ${markerDiameter}px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
          ">
            <span class="material-icons" style="
              font-size: ${isCompact ? 16 : 20}px;
              color: white;
            ">error</span>
          </div>
        `,
      });
    }

    const isGradient = fillColor.includes("gradient");
    const backgroundStyle = isGradient
      ? `background: ${fillColor};`
      : `background-color: ${fillColor};`;

    // console.log("isGradient: ", isGradient);
    // console.log("backgroundStyle: ", backgroundStyle);

    const symbolColor = transportSymbolColor(transportType as string);

    const iconHtml = `
      <span class="material-icons" style="
        font-size: ${transportIconFontSize}px;
        color: ${symbolColor};
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        border-radius: 15px 15px 0px;
      ">${materialString}</span>
    `;

    return L.divIcon({
      className: "custom-div-icon",
      iconSize: iconSize,
      iconAnchor: iconAnchor,
      popupAnchor: popupAnchor,
      html: `
        <div style="
          ${backgroundStyle}
          border: 2px solid ${materialIcon.borderColor[transportType]};
          width: ${markerDiameter}px;
          height: ${markerDiameter}px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
        ">
          ${iconHtml}
        </div>
      `,
    });
  }

  /**
   * Create a composite material icon marker by stacking a base icon with an overlay icon.
   * Useful for combined modes like Bike & Ride.
   */
  getCompositeMaterialIcon(
    baseMaterialString: string,
    overlayMaterialString: string,
    transportType: keyof typeof materialIcon.fillColor,
    sizeVariant: "default" | "compact" = "default",
  ) {
    const isCompact = sizeVariant === "compact";
    const iconSize = isCompact
      ? this.compactMaterialIconSize
      : this.defaultMaterialIconSize;
    const iconAnchor: [number, number] = isCompact ? [14, 28] : [17.5, 35];
    const popupAnchor: [number, number] = isCompact ? [0, -28] : [0, -35];
    const markerDiameter = isCompact ? 24 : 30;

    // Detect if fillColor is a gradient or solid color
    const fillColor = materialIcon.fillColor[transportType];
    const isGradient = fillColor.includes("gradient");
    const backgroundStyle = isGradient
      ? `background: ${fillColor};`
      : `background-color: ${fillColor};`;

    const symbolColor = transportSymbolColor(transportType as string);

    const baseIcon = `
      <span class="material-icons" style="
        font-size: ${isCompact ? 16 : 20}px;
        color: ${symbolColor};
        line-height: 1;
      ">${baseMaterialString}</span>
    `;

    const overlayIcon = `
      <span class="material-icons" style="
        position: absolute;
        right: ${isCompact ? 1 : 2}px;
        bottom: ${isCompact ? 1 : 2}px;
        font-size: ${isCompact ? 11 : 14}px;
        color: ${symbolColor};
      ">${overlayMaterialString}</span>
    `;

    return L.divIcon({
      className: "custom-div-icon",
      iconSize: iconSize,
      iconAnchor: iconAnchor,
      popupAnchor: popupAnchor,
      html: `
        <div style="
          position: relative;
          ${backgroundStyle}
          border: 2px solid ${materialIcon.borderColor[transportType]};
          width: ${markerDiameter}px;
          height: ${markerDiameter}px;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          padding-left: ${isCompact ? 0 : 1}px;
          padding-top: ${isCompact ? 0 : 1}px;
          border-radius: 50%;
        ">
          ${baseIcon}
          ${overlayIcon}
        </div>
      `,
    });
  }

  /**
   * Create a circular numbered icon for the MultipleAlternatives map.
   * Shows the count of matching alternatives, colored by the best transport type.
   */
  getNumberedIcon(
    count: number,
    transportColorKey: keyof typeof materialIcon.fillColor | null,
    sizeVariant: "default" | "compact" = "default",
  ): L.DivIcon {
    const isCompact = sizeVariant === "compact";
    const iconSize: [number, number] = isCompact
      ? this.compactMaterialIconSize
      : this.defaultMaterialIconSize;
    const iconAnchor: [number, number] = isCompact ? [14, 28] : [17.5, 35];
    const popupAnchor: [number, number] = isCompact ? [0, -28] : [0, -35];
    const markerDiameter = isCompact ? 24 : 30;
    const fontSize = isCompact ? 13 : 16;

    // Use the transport's fill/border color, fall back to grey if no key provided
    let bgColor: string;
    let borderColor: string;
    if (!transportColorKey) {
      bgColor = "#9E9E9E";
      borderColor = "#616161";
    } else {
      bgColor = materialIcon.fillColor[transportColorKey] || "#9E9E9E";
      borderColor = materialIcon.borderColor[transportColorKey] || "#616161";
    }

    const backgroundStyle = bgColor.includes("gradient")
      ? `background: ${bgColor};`
      : `background-color: ${bgColor};`;

    return L.divIcon({
      className: "custom-div-icon",
      iconSize: iconSize,
      iconAnchor: iconAnchor,
      popupAnchor: popupAnchor,
      html: `
        <div style="
          ${backgroundStyle}
          border: 2px solid ${borderColor};
          width: ${markerDiameter}px;
          height: ${markerDiameter}px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
        ">
          <span style="
            font-size: ${fontSize}px;
            font-weight: bold;
            color: ${transportSymbolColor(transportColorKey as string)};
            line-height: 1;
          ">${count}</span>
        </div>
      `,
    });
  }

  getDefaultIcon(): L.DivIcon {
    // console.log("Getting default icon");
    const markerHtmlStyles = `
      background-color: rgba(255, 255, 255, 0.6);
      height: 22px;
      width: 22px;
      transform: rotate(45deg);
      border-radius: 15px 15px 0px;
      position: absolute;
      border-style: solid;
      border-width: 2px;
    `;

    return L.divIcon({
      className: "my-custom-pin",
      iconAnchor: [11, 22],
      popupAnchor: [0, -36],
      html: `<span style="${markerHtmlStyles}"></span>`,
    });
  }
}
